import { createGlobalStyle, keyframes } from 'styled-components';
import { Theme } from './theme/types';
import { defaultStyles } from './constants';
import { isDarkTheme } from './theme/helpers';

const addBorderTop = (borderColor: string) => keyframes`
  0% {
    border-top: 0 solid transparent;
  }
  100% {
    border-top: 1px solid ${borderColor};
  }
`;

export const GlobalStyles = createGlobalStyle<{ theme: Theme }>`
  html,
  body,
  .app,
  #__next {
    -webkit-overflow-scrolling: touch;
  }

  html {
    box-sizing: border-box;
    overflow-y: auto;
    scrollbar-gutter: stable;
    background-color: ${({ theme }) => (isDarkTheme(theme) ? theme.colors.background.primary : 'initial')};
  }

  *,
  *::before,
  *::after {
    box-sizing: inherit;
  }

  body {
    margin: 0;
    padding: 0;
    font: normal ${defaultStyles.baseFontSize} ${defaultStyles.fontFamily};
    color: ${({ theme: { colors } }) => colors.text.primary};
    -webkit-font-smoothing: antialiased;
  }

  section,
  article,
  nav,
  header,
  footer,
  aside,
  figure {
    display: block;
  }

  a {
    color: #333;
    text-decoration: underline;
    outline: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

    img {
      border: 0;
    }
  }

  h3 {
    margin-top: 0;
    font-size: 18px;
    line-height: 25px;
    margin-bottom: 7px;
    font-weight: bold;
  }

  ul {
    margin: 0;
    padding: 0;

    li {
      list-style-type: none;
      margin: 0;
      padding: 0;
    }
  }

  button {
    border: 0;
    outline: none;
    appearance: none;
  }

  .area {
    white-space: nowrap;
  }

  .main-content {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background-color: ${({ theme: { colors } }) => colors.background.primary};

    @media screen and (orientation: landscape) {
      min-height: 320px;
    }
  }

  .preload {
    width: calc(100% - 0px);
    position: fixed;
    overflow: hidden;
    top: 0;
    bottom: 0;

    * {
      transition: none !important;
    }
  }

  .is-hidden {
    display: none !important;
  }

  .modal__portal--opened-top .modal__content {
    animation: showFromTop 0.5s forwards ease-in-out;

    &--header-menu {
      animation: ${({ theme: { colors } }) => addBorderTop(colors.border.primary)} 0.5s forwards ease-in-out;
    }
  }

  .modal__content--header-menu {
    position: relative;
    left: 0;
    right: 0;
    height: fit-content;
    background: ${({ theme: { colors } }) => colors.background.primary};
    overflow-y: hidden;
  }

  .auth-modal-overlay {
    z-index: 70001; // to hide bg banner
  }
`;
